(function(){
  function equalizeCards(){
    var cardSelectors = ['.product-card','.product-item','.grid__item','.grid-item','.product-grid-item','.product-list-item'];
    var cards = [];
    cardSelectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if(!cards.includes(el)) cards.push(el);
      });
    });
    if(cards.length === 0) return;
    cards.forEach(function(c){ c.style.height='auto'; var info=c.querySelector('.product-info, .product-item__info, .grid__meta, .product-details'); if(info) info.style.minHeight='';});
    var maxInfoH=0;
    cards.forEach(function(c){
      var info=c.querySelector('.product-info, .product-item__info, .grid__meta, .product-details');
      var h = info ? info.getBoundingClientRect().height : c.getBoundingClientRect().height;
      if(h>maxInfoH) maxInfoH=h;
    });
    if(maxInfoH>0){
      cards.forEach(function(c){
        var info=c.querySelector('.product-info, .product-item__info, .grid__meta, .product-details');
        if(info) info.style.minHeight = (maxInfoH) + 'px';
      });
    }
    var maxCardH=0;
    cards.forEach(function(c){ var h=c.getBoundingClientRect().height; if(h>maxCardH) maxCardH=h; });
    if(maxCardH>0) cards.forEach(function(c){ c.style.height = (maxCardH) + 'px'; });
  }
  function run(){ try{ equalizeCards(); }catch(e){} }
  window.addEventListener('load', run);
  var rTO;
  window.addEventListener('resize', function(){ clearTimeout(rTO); rTO = setTimeout(run,300); });
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(run,500); });
})();
